import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { LanguageProvider } from './context/LanguageContext';
import Home from './pages/Home';
import Menu from './pages/Menu';
import Imprint from './pages/Imprint';
import Privacy from './pages/Privacy';
import Journal from './pages/Journal';
import ArticleLaBarberenca from './pages/ArticleLaBarberenca';

function App() {
  return (
    <LanguageProvider>
      <Router>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/menu/:id" element={<Menu />} />
          <Route path="/imprint" element={<Imprint />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/journal" element={<Journal />} />
          <Route path="/journal/la-barberenca" element={<ArticleLaBarberenca />} />
        </Routes>
      </Router>
    </LanguageProvider>
  );
}

export default App;